/*
 * Stane winactie: Klaviyo-opt-in formulier (creator- en adspagina).
 * Bron: design-input/2026-10-13-winactie/formcode/creator-page.html (aangeleverd door het bureau), 13-10-2026.
 * 4 wijzigingen gemarkeerd met // STANE-THEME: (instellingen uit de sectie, placeholder, voorwaarden alleen mét URL,
 * theme-editor). Verder letterlijk de aangeleverde code.
 */
(function () {
  "use strict";

  /* ========================= SETTINGS ========================= */

  // STANE-THEME: instellingen uit de sectie (data-attributen op de eerste root met een lijst-id).
  // De waarden uit de aangeleverde code zijn de terugval; creators en voorwaarden hebben bewust géén
  // terugval, zodat er geen "Creator 1" of een niet-bestaande voorwaardenpagina live kan gaan.
  var CFG = (function () {
    var r = document.querySelector("[data-stane-giveaway][data-klaviyo-lijst]");
    return r ? r.dataset : {};
  })();
  var KLAVIYO_COMPANY_ID = CFG.klaviyoCompany || "TuM5jk";
  var KLAVIYO_LIST_ID = CFG.klaviyoLijst || "TMzn2e";
  var CREATORS = String(CFG.creators || "").split("\n").map(function (s) { return s.trim(); }).filter(Boolean);
  var ACTIEVOORWAARDEN_URL = CFG.voorwaarden || "";
  var INSTAGRAM_POST_URL = CFG.instagram || "";

  // Fixed values: only change these if you know why
  var GIVEAWAY_BRON = "giveaway_okt_2026";
  var KLAVIYO_REVISION = "2026-07-15";
  var KLAVIYO_ENDPOINT = "https://a.klaviyo.com/client/subscriptions?company_id=";
  var CUSTOM_SOURCE = "Winactie oktober 2026 - opt-inpagina";
  var ADS_CREATOR_WAARDE = "Advertentie (geen creator)"; // giveaway_creator value on the ads page

  /* ============================================================ */

  if (window.__staneGiveawayLoaded) return;
  window.__staneGiveawayLoaded = true;

  var ANDERS = "Anders / geen creator";
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var instances = [];
  var done = false;

  function slug(s) {
    return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]/g, "");
  }

  // Creator from the link: ?creator=... or utm_content=...
  var linkCreator = (function () {
    try {
      var p = new URLSearchParams(window.location.search);
      // utm_content only counts with utm_medium=creator; ads use utm_content for the concept name
      var raw = p.get("creator") || (p.get("utm_medium") === "creator" ? p.get("utm_content") : "") || "";
      if (!raw) return { raw: "", match: "" };
      var key = slug(raw);
      var match = "";
      for (var i = 0; i < CREATORS.length; i++) { if (slug(CREATORS[i]) === key) { match = CREATORS[i]; break; } }
      return { raw: raw.slice(0, 60), match: match };
    } catch (e) { return { raw: "", match: "" }; }
  })();

  function el(tag, attrs, text) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) { if (attrs[k] !== null && attrs[k] !== undefined) e.setAttribute(k, attrs[k]); }
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  }

  function selectField(id, label, placeholder, options, selected) {
    var wrap = el("div", { "class": "stane-giveaway-field" });
    wrap.appendChild(el("label", { "class": "stane-giveaway-label", "for": id }, label));
    var sel = el("select", { "class": "stane-giveaway-select", id: id, name: id, required: "", "aria-describedby": id + "-fout", "aria-invalid": "false" });
    var ph = el("option", { value: "" }, placeholder);
    ph.disabled = true;
    sel.appendChild(ph);
    options.forEach(function (o) { sel.appendChild(el("option", { value: o }, o)); });
    sel.value = selected || "";
    wrap.appendChild(sel);
    wrap.appendChild(el("p", { "class": "stane-giveaway-error", id: id + "-fout", role: "alert" }));
    return { wrap: wrap, input: sel };
  }

  function build(root, n) {
    var p = "stane-giveaway-" + n + "-";
    var kanaal = root.getAttribute("data-kanaal") === "ads" ? "ads" : "creators";
    root.textContent = "";

    var form = el("form", { "class": "stane-giveaway-form", novalidate: "" });

    // First name
    var fNaam = el("div", { "class": "stane-giveaway-field" });
    fNaam.appendChild(el("label", { "class": "stane-giveaway-label", "for": p + "voornaam" }, "Je voornaam"));
    var voornaam = el("input", { "class": "stane-giveaway-input", type: "text", id: p + "voornaam", name: "voornaam", autocomplete: "given-name", maxlength: "60", required: "", "aria-describedby": p + "voornaam-fout", "aria-invalid": "false" });
    fNaam.appendChild(voornaam);
    fNaam.appendChild(el("p", { "class": "stane-giveaway-error", id: p + "voornaam-fout", role: "alert" }));
    form.appendChild(fNaam);

    // E-mail
    var fEmail = el("div", { "class": "stane-giveaway-field" });
    fEmail.appendChild(el("label", { "class": "stane-giveaway-label", "for": p + "email" }, "Je e-mailadres"));
    // STANE-THEME: placeholder op het e-mailveld (ontbrak in de aangeleverde code)
    var email = el("input", { "class": "stane-giveaway-input", type: "email", id: p + "email", name: "email", autocomplete: "email", inputmode: "email", placeholder: "jij@voorbeeld.nl", required: "", "aria-describedby": p + "email-fout", "aria-invalid": "false" });
    fEmail.appendChild(email);
    fEmail.appendChild(el("p", { "class": "stane-giveaway-error", id: p + "email-fout", role: "alert" }));
    form.appendChild(fEmail);


    // Creator
    // Creator choice only on the creator page; the ads page (data-kanaal="ads") has no such field
    var creator = null;
    if (kanaal === "creators") {
      creator = selectField(p + "creator", "Via welke creator kwam je hier?", "Kies een creator", CREATORS.concat([ANDERS]), linkCreator.match);
      form.appendChild(creator.wrap);
    }

    // Honeypot
    var hpWrap = el("div", { "class": "stane-giveaway-hp", "aria-hidden": "true" });
    hpWrap.appendChild(el("label", { "for": p + "website" }, "Laat dit veld leeg"));
    var hp = el("input", { type: "text", id: p + "website", name: "website", tabindex: "-1", autocomplete: "off" });
    hpWrap.appendChild(hp);
    form.appendChild(hpWrap);

    var button = el("button", { "class": "stane-giveaway-button", type: "submit" }, "Doe mee");
    form.appendChild(button);

    var status = el("p", { "class": "stane-giveaway-status", role: "alert" });
    form.appendChild(status);

    form.appendChild(el("p", { "class": "stane-giveaway-small" }, "Je ontvangt onze e-mails over gezond werken en onze aanbiedingen. Afmelden kan altijd met één klik."));
    // STANE-THEME: actievoorwaarden alleen tonen als er een URL is ingesteld (besluit Jory 13-10)
    // Eén regel vanaf 360 px, zonder leeftijdszin (Jory 14-10); de 18+-eis staat in de actievoorwaarden zelf
    if (ACTIEVOORWAARDEN_URL) {
      var terms = el("p", { "class": "stane-giveaway-small" });
      terms.appendChild(document.createTextNode("Door mee te doen accepteer je de "));
      terms.appendChild(el("a", { "class": "stane-giveaway-link", href: ACTIEVOORWAARDEN_URL, target: "_blank", rel: "noopener" }, "actievoorwaarden"));
      terms.appendChild(document.createTextNode("."));
      form.appendChild(terms);
    }

    root.appendChild(form);

    var inst = { root: root, kanaal: kanaal, form: form, voornaam: voornaam, email: email, creator: creator ? creator.input : null, hp: hp, button: button, status: status };

    // Clear the error as soon as the field is valid
    [voornaam, email, inst.creator].filter(Boolean).forEach(function (f) {
      f.addEventListener(f.tagName === "SELECT" ? "change" : "input", function () {
        if (f.getAttribute("aria-invalid") === "true") { var msg = check(inst, f); setError(f, msg); }
      });
    });

    form.addEventListener("submit", function (ev) { ev.preventDefault(); submit(inst); });
    return inst;
  }

  function setError(field, msg) {
    var box = document.getElementById(field.id + "-fout");
    if (box) box.textContent = msg || "";
    field.setAttribute("aria-invalid", msg ? "true" : "false");
  }

  function check(inst, field) {
    if (field === inst.email) {
      var v = inst.email.value.trim();
      if (!v) return "Vul je e-mailadres in.";
      if (!EMAIL_RE.test(v)) return "Dit e-mailadres klopt niet. Kijk even of er geen tikfout in zit.";
      return "";
    }
    if (field === inst.voornaam) return inst.voornaam.value.trim() ? "" : "Vul je voornaam in.";
    if (field === inst.creator) return inst.creator.value ? "" : "Kies via welke creator je hier kwam, of kies “Anders / geen creator”.";
    return "";
  }

  function validate(inst) {
    var first = null;
    [inst.voornaam, inst.email, inst.creator].filter(Boolean).forEach(function (f) {
      var msg = check(inst, f);
      setError(f, msg);
      if (msg && !first) first = f;
    });
    if (first) first.focus();
    return !first;
  }

  function setBusy(inst, busy) {
    inst.button.disabled = busy;
    inst.button.textContent = busy ? "Bezig met inschrijven..." : "Doe mee";
    inst.form.setAttribute("aria-busy", busy ? "true" : "false");
  }

  function showSuccess(focusInst) {
    done = true;
    instances.forEach(function (inst) {
      var box = el("div", { "class": "stane-giveaway-success" });
      var title = el("h2", { "class": "stane-giveaway-success-title", tabindex: "-1" }, "Gelukt — je doet mee.");
      box.appendChild(title);
      box.appendChild(el("p", null, "We hebben je een bevestiging gestuurd."));
      if (INSTAGRAM_POST_URL) {
        var p = el("p");
        p.appendChild(document.createTextNode("Ken je iemand die dit ook kan gebruiken? Tag diegene onder "));
        p.appendChild(el("a", { "class": "stane-giveaway-link", href: INSTAGRAM_POST_URL, target: "_blank", rel: "noopener" }, "onze Instagram-post"));
        p.appendChild(document.createTextNode("."));
        box.appendChild(p);
      }
      inst.root.textContent = "";
      inst.root.appendChild(box);
      if (inst === focusInst) title.focus();
    });
  }

  function configOk() {
    var ok = /^[A-Za-z0-9]{6}$/.test(KLAVIYO_COMPANY_ID) && /^[A-Za-z0-9]{6}$/.test(KLAVIYO_LIST_ID);
    if (!ok) console.error("[Stane winactie] KLAVIYO_COMPANY_ID of KLAVIYO_LIST_ID is niet (goed) ingevuld.");
    return ok;
  }

  function submit(inst) {
    if (done || inst.button.disabled) return;
    inst.status.textContent = "";
    if (!validate(inst)) return;

    // A bot filled the honeypot: pretend success, send nothing
    if (inst.hp.value) { showSuccess(inst); return; }

    if (!configOk()) {
      inst.status.textContent = "Inschrijven lukt nu niet door een technisch probleem aan onze kant. Probeer het later opnieuw.";
      return;
    }

    var emailValue = inst.email.value.trim();
    var payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: CUSTOM_SOURCE + (inst.kanaal === "ads" ? " (advertenties)" : " (creators)"),
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: emailValue,
                first_name: inst.voornaam.value.trim().slice(0, 60),
                subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } },
                properties: {
                  giveaway_bron: GIVEAWAY_BRON,
                  giveaway_kanaal: inst.kanaal,
                  giveaway_creator: inst.creator ? inst.creator.value : ADS_CREATOR_WAARDE,
                  giveaway_creator_link: inst.creator ? (linkCreator.match || linkCreator.raw) : ""
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: "list", id: KLAVIYO_LIST_ID } } }
      }
    };

    setBusy(inst, true);
    fetch(KLAVIYO_ENDPOINT + encodeURIComponent(KLAVIYO_COMPANY_ID), {
      method: "POST",
      headers: {
        "accept": "application/vnd.api+json",
        "content-type": "application/vnd.api+json",
        "revision": KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      // 202 = success. A duplicate signup also returns 202; 409 is treated as success too, to be safe.
      if (res.ok || res.status === 409) {
        try { if (typeof window.fbq === "function") window.fbq("track", "Lead"); } catch (e) {}
        try { if (window.klaviyo && typeof window.klaviyo.identify === "function") window.klaviyo.identify({ email: emailValue }); } catch (e) {}
        showSuccess(inst);
        return;
      }
      return res.text().then(function (body) {
        console.error("[Stane winactie] Klaviyo-fout " + res.status + ":", body);
        setBusy(inst, false);
        inst.status.textContent = res.status === 429
          ? "Het is even erg druk. Wacht een paar seconden en probeer het opnieuw. Je gegevens staan er nog."
          : "Er ging iets mis bij het inschrijven. Je gegevens staan er nog, dus probeer het over een paar seconden opnieuw.";
      });
    }).catch(function (err) {
      console.error("[Stane winactie] Netwerkfout bij inschrijven:", err);
      setBusy(inst, false);
      inst.status.textContent = "We konden je inschrijving niet versturen. Controleer je internetverbinding en probeer het opnieuw. Je gegevens staan er nog.";
    });
  }

  function init() {
    var roots = document.querySelectorAll("[data-stane-giveaway]");
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute("data-stane-giveaway-ready")) continue;
      roots[i].setAttribute("data-stane-giveaway-ready", "1");
      roots[i].classList.add("stane-giveaway");
      instances.push(build(roots[i], instances.length + 1));
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // STANE-THEME: een sectie die de theme-editor opnieuw rendert, krijgt weer een formulier
  document.addEventListener("shopify:section:load", init);
})();
